export default {
  reports: [],
  pageable: null,
  countryCodes: []
};
